// extracted by mini-css-extract-plugin
export default {"containerFlex":"containerFlex_containerFlex__GrtoV","panelLeft":"containerFlex_panelLeft__d2zzX","panelRight":"containerFlex_panelRight__vaQfp"};